import { useEffect, useState } from "react";
import { useGetHistoricalSurvey } from "../Hooks/useGetHistoricalSurvey";
import { toast } from "react-hot-toast";
import { useForm } from "react-hook-form";

import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  LinearProgress,
  Button,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Grid,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CUEncuestaRetiro from "../pages/pageC&UEncuestaRetiro";
import { format, parse } from "date-fns";
import { es } from "date-fns/locale";

const ModalViewRetirement = ({ handleOpenDialog, open, rowData, isTable }) => {
  const theme = useTheme();
  const bitMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const [loading, setLoading] = useState(false);
  const [error, setErrors] = useState(null);
  const [expandedIndexes, setExpandedIndexes] = useState([]);

  const { data, refreshGetData, clearData } = useGetHistoricalSurvey({ autoLoad: false });

  const {
    control,
    formState: { errors },
  } = useForm({ mode: "onChange" });

  useEffect(() => {
    if (open && rowData?.strEmail) {
      setLoading(true);
      refreshGetData({ strEmail: rowData.strEmail })
        .then(() => setLoading(false))
        .catch((err) => {
          setErrors(err.message || "Error al cargar históricos.");
          toast.error(err.message);
          setLoading(false);
        });
    }
    if (!open) {
      setErrors(null);
      clearData();
      setExpandedIndexes([]);
    }
  }, [open, rowData, refreshGetData, clearData]);

  const historicos = data?.error ? [] : data || [];

  const handleToggleAccordion = (index) => {
    setExpandedIndexes((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    );
  };

  const expandAll = () => setExpandedIndexes(historicos.map((_, i) => i));
  const collapseAll = () => setExpandedIndexes([]);

  // ✅ Función para formatear fecha
  const formatDate = (dateString) => {
    if (!dateString) return "Sin fecha";

    const fecha = parse(
      dateString.substring(0, 10),
      "yyyy-MM-dd",
      new Date()
    );

    return format(fecha, "d 'de' MMMM 'de' yyyy", { locale: es });
  };

  return (
    <Dialog
      open={open}
      onClose={handleOpenDialog}
      fullWidth
      maxWidth="xl"
      PaperProps={{
        style: {
          width: "90vw",
          height: "90vh",
          backgroundColor: "#f9f9f9",
          borderRadius: "8px",
          padding: "16px",
        },
      }}
    >
      {loading && <LinearProgress />}
      <DialogTitle>Histórico de Encuestas de Retiro</DialogTitle>

      <DialogContent>
        {loading ? (
          <Typography>Cargando históricos...</Typography>
        ) : error ? (
          <Typography color="error">{error}</Typography>
        ) : (
          <>
            {/* ✅ Botones para expandir/colapsar todos */}
            {historicos.length > 0 && (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: bitMobile ? "column" : "row",
                  gap: 1,
                  mb: 2,
                  alignItems: "center",
                }}
              >
                <Button size="small" variant="outlined" onClick={expandAll}>
                  Expandir todos
                </Button>
                <Button size="small" variant="outlined" onClick={collapseAll}>
                  Colapsar todos
                </Button>
              </Box>
            )}

            {/* ✅ Scroll mejorado */}
            <Box sx={{ maxHeight: "70vh", overflowY: "auto" }}>
              {historicos.length === 0 ? (
                <Typography>No hay históricos disponibles.</Typography>
              ) : (
                historicos.map((item, index) => (
                  <Accordion
                    key={index}
                    expanded={expandedIndexes.includes(index)}
                    onChange={() => handleToggleAccordion(index)}
                    sx={{
                      mb: 1,
                      borderRadius: "6px",
                      boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                      backgroundColor: "#fff",
                    }}
                  >
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={3}>
                          <Typography variant="body2">
                            <b>Fecha:</b> {formatDate(item.dtFechaRetiro)}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={2}>
                          <Typography variant="body2">
                            <b>Tipo:</b> {item.strTipoRetiro || "No definido"}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <Typography variant="body2">
                            <b>Motivo:</b> {item.strMotivoRetiroUno || "No definido"}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={3}>
                          <Typography variant="body2">
                            <b>Estado:</b> {item.btRealizoEncuesta ? "Inactivo" : "Activo"}
                          </Typography>
                        </Grid>
                      </Grid>
                    </AccordionSummary>
                    <AccordionDetails>
                      {/* ✅ Aquí irá tu componente de detalle */}
                      <CUEncuestaRetiro
                        isPreview
                        // isActive={item?.btRealizoEncuesta}
                        values={item}
                        handleOpenDialog={handleOpenDialog}
                        isTable={isTable}
                      />
                    </AccordionDetails>
                  </Accordion>
                ))
              )}
            </Box>
          </>
        )}
      </DialogContent>

      <DialogActions>
        <Button onClick={handleOpenDialog} color="inherit" disabled={loading}>
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModalViewRetirement;